/* EE, pré-tráfego (28/09/2026, chat Site · Ajustes pré-tráfego). Carregado pela seção "EE custom CSS" do rodapé.
   "Pick your color" (seção ee_pick_color da página de produto): o clique num card troca a cor
   no seletor de variante do tema, sem recarregar a página, mantém o tamanho escolhido,
   move o ✓ e rola até a galeria. Se o seletor não for achado, o link normal continua valendo. */
(function () {
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function findInput(name) {
    var pickers = document.querySelectorAll('variant-picker');
    for (var i = 0; i < pickers.length; i++) {
      if (pickers[i].closest('dialog')) continue;
      var inputs = pickers[i].querySelectorAll('input[type="radio"]');
      for (var j = 0; j < inputs.length; j++) {
        if (norm(inputs[j].value) === name) return inputs[j];
      }
    }
    return null;
  }
  function markCurrent(item) {
    var items = document.querySelectorAll('.ee-colors__item');
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var label = it.querySelector('.ee-colors__label');
      var check = label && label.querySelector('span[aria-hidden="true"]');
      if (it === item) {
        it.setAttribute('aria-current', 'true');
        if (label && !check) {
          var s = document.createElement('span');
          s.setAttribute('aria-hidden', 'true');
          s.textContent = '✓';
          label.appendChild(s);
        }
      } else {
        it.removeAttribute('aria-current');
        if (check) check.remove();
      }
    }
  }
  function scrollToGallery() {
    var g = document.querySelector('.shopify-section[id$="__main"] .product-information__media') ||
            document.querySelector('.product-information__media');
    if (!g) return;
    var top = g.getBoundingClientRect().top + window.pageYOffset;
    var header = document.querySelector('header, .header');
    var offset = header ? Math.min(header.getBoundingClientRect().height, 120) + 12 : 12;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top - offset), behavior: reduce ? 'auto' : 'smooth' });
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var item = e.target && e.target.closest ? e.target.closest('.ee-colors__item') : null;
    if (!item) return;
    var nameEl = item.querySelector('.ee-colors__label span');
    if (!nameEl) return;
    var input = findInput(norm(nameEl.textContent));
    if (!input) return;
    e.preventDefault();
    if (!input.checked) input.click();
    markCurrent(item);
    scrollToGallery();
  });
})();

/* Join the Crew (seção ee-newsletter-split da home), 18/10/2026: o formulário continua sendo o da
   Shopify (form 'customer', tag newsletter), que cria o cliente com aceite de marketing; o Klaviyo põe
   na lista "Email List" (Rn6Gzq) na hora e dispara o Welcome. A Shopify roda uma verificação anti-robô
   no envio e depois chama form.submit(); aqui esse submit() do formulário manda por trás (fetch, já com
   a verificação) e mostra "You're in" sem recarregar. Se a resposta não vier com customer_posted=true,
   o envio normal acontece (a página recarrega, como antes). Testes que falharam: fetch no evento de
   envio (sem a verificação) e iframe escondido (a Shopify não deixa abrir a loja em iframe). */
(function () {
  var OK = "You're in. See you out there.";
  var nativeSubmit = HTMLFormElement.prototype.submit;
  function done(f) {
    var input = f.querySelector('input[type="email"]');
    var msg = f.querySelector('.ee-nl__msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'ee-nl__msg';
      msg.setAttribute('role', 'status');
      f.appendChild(msg);
    }
    msg.textContent = OK;
    if (input) input.value = '';
  }
  function send(f) {
    var btn = f.querySelector('button[type="submit"]');
    if (!window.fetch || !window.FormData) { nativeSubmit.call(f); return; }
    if (btn) btn.disabled = true;
    fetch(f.action, { method: 'POST', body: new FormData(f), credentials: 'same-origin' })
      .then(function (r) {
        if (btn) btn.disabled = false;
        if (r.ok && r.url.indexOf('customer_posted=true') > -1) done(f);
        else nativeSubmit.call(f);
      })
      .catch(function () { if (btn) btn.disabled = false; nativeSubmit.call(f); });
  }
  function arm(f) {
    if (f.__eeArmed) return;
    f.__eeArmed = true;
    f.submit = function () { send(f); };
  }
  function armAll() {
    var fs = document.querySelectorAll('form.ee-nl__form');
    for (var i = 0; i < fs.length; i++) arm(fs[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armAll); else armAll();
  /* Ninguém segurou o envio (sem verificação): manda por trás aqui. */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('ee-nl__form') || e.defaultPrevented) return;
    arm(f);
    e.preventDefault();
    send(f);
  });
})();